import { render, staticRenderFns } from "./jointOrderAAdd.vue?vue&type=template&id=3acc2210&scoped=true&"
import script from "./jointOrderAAdd.vue?vue&type=script&lang=js&"
export * from "./jointOrderAAdd.vue?vue&type=script&lang=js&"
import style0 from "./jointOrderAAdd.vue?vue&type=style&index=0&id=3acc2210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc2210",
  null
  
)

export default component.exports